@reference "~/styles.css";

@layer components {
	.skeleton {
		@apply animate-pulse! motion-reduce:animate-none! cursor-wait! bg-grey-400! select-none!;
	}

	.skeletonTextLine {
		composes: skeleton;
		@apply inline-block max-w-full rounded-[0.2em];
	}

	.skeletonBox {
		composes: skeleton;
		@apply leading-none rounded-sm text-transparent! shadow-none! border-transparent! outline-hidden! ring-0! *:opacity-0! *:pointer-events-none!;

		:has(&) {
			@apply no-underline!;
		}
	}
}
